// extracted by mini-css-extract-plugin
export default {"panel":"node-panel_panel__PObhG","panelRight":"node-panel_panelRight__cicAU"};